<template>
  <div v-if="question">

    <info-and-auth-bar :title="`Bearbeitung Quizvorlage „${quiz.name}“ Frage #${parseInt($route.params.question) + 1 }`"
                       :back-link="`/e/${quiz.id}`" back-name="Quiz" />

    <div class="grid" style="grid-template-columns: 4rem 1fr 4rem;">

      <!-- left button -->
      <div class="flex justify-center items-center ml-4" style="height: calc(100vh - 2.26rem);">
        <button v-show="hasLeftQuestion" class="button" @click="goToQuestion(false)">
          <font-awesome-icon icon="chevron-left" size="lg" />
        </button>
      </div>

      <!-- content -->
      <div class="container p-8 grid" style="grid-template-columns: 1fr 5px 1fr;">

        <!-- left column -->
        <div>

          <!-- edit name -->
          <div class="form-group">
            <label class="form-label" for="name">Frage</label>
            <input id="name" :value="question.title" class="form-input" placeholder="Name" type="text"
                   @change="updateQuestion({ title: $event.target.value })">
          </div>

          <!-- edit question type -->
          <div class="form-group">
            <label class="form-label">Fragentyp</label>
            <label class="form-radio">
              <input :checked="question.type === QUESTION_TYPES.EXPERIENCE" name="type" type="radio"
                     @click="updateQuestion({type: QUESTION_TYPES.EXPERIENCE})">
              <i class="form-icon"></i> {{ QUESTION_TYPES.EXPERIENCE }}
            </label>
            <label class="form-radio">
              <input :checked="question.type === QUESTION_TYPES.KNOWLEDGE" name="type" type="radio"
                     @click="updateQuestion({type: QUESTION_TYPES.KNOWLEDGE})">
              <i class="form-icon"></i> {{ QUESTION_TYPES.KNOWLEDGE }}
            </label>
          </div>

          <div class="form-group">
            <label class="form-label">Zeitpunkte</label>
            <label class="form-checkbox">
              <input :checked="typeof question.timeBonus == 'undefined' ? true : question.timeBonus" type="checkbox"
                     @click="updateQuestion({timeBonus: $event.target.checked})">
              <i class="form-icon"></i> Zeitbonus aktiviert
            </label>
          </div>

          <!-- media preview -->
          <div>
            <label class="form-label">Mediendatei</label>

            <button class="btn" @click="openMediaPopup">Mediendatei
              {{ mediaObject ? 'ändern' : 'auswählen' }}
            </button>
            <button v-if="mediaObject" class="btn btn-link" @click="deleteMedia">
              Mediendatei löschen
            </button>

            <img v-if="mediaObject && mediaObject.meta.contentType.startsWith('image/')" :alt="mediaObject.name"
                 :src="mediaObject.url" :title="mediaObject.name" class="w-1/2 mt-2" />
            <video v-if="mediaObject && mediaObject.meta.contentType.startsWith('video/')" :src="mediaObject.url"
                   :title="mediaObject.name" class="bg-black w-1/2 mt-2" controls />
          </div>

          <!-- timer duration settings -->
          <div class="form-group">
            <label class="form-label" for="timer-duration">Timerdauer in Sekunden</label>
            <input id="timer-duration"
                   :value="question.timerDuration >= 0 ? question.timerDuration : $store.state.settings.timerDuration"
                   class="form-input" placeholder="Timerdauer" type="number"
                   @change="updateQuestion({timerDuration: parseInt($event.target.value) >= 0 ? parseInt($event.target.value) : 30})">
          </div>

          <!-- timer sound settings -->
          <div class="form-group">
            <label class="form-label" for="timer-sound">
              Timersound
              <span v-if="!this.question.timerSound">ist Standardeinstellung</span>
            </label>
            <button id="timer-sound" class="btn" @click="selectSound">Anderen Sound wählen</button>
            <p v-if="timerSound && timerSoundMediaObject" class="inline-block ml-4">Ausgewählt:
              {{ timerSoundMediaObject.name }}</p>
            <audio v-if="timerSound && timerSoundMediaObject" :src="timerSoundMediaObject.url" class="block mt-2 w-full"
                   controls></audio>
          </div>

        </div>

        <!-- divider -->
        <div class="divider-vert"></div>

        <!-- question content column -->
        <div>

          <label class="mb-2 block">Antwortoptionen</label>

          <div v-for="(option, id) in question.options" class="input-group mb-2 flex flex-row items-center">

            <!-- correct answer switch -->
            <label class="form-switch">
              <input :checked="id === question.correct" :disabled="question.type !== QUESTION_TYPES.KNOWLEDGE"
                     type="checkbox" @click.prevent="setCorrect(id)"><i class="form-icon"></i>
            </label>

            <!-- edit option -->
            <input :placeholder="`Antwortmöglichkeit ${id + 1}`" :value="option" class="form-input" type="text"
                   @change="updateOption(id, $event.target.value)">

            <!-- delete button -->
            <button class="btn btn-link">
              <font-awesome-icon :icon="['fas', 'times']" class="ml-2" size="lg"
                                 @click="removeOption(id)"></font-awesome-icon>
            </button>
          </div>
          <button class="btn btn-link" @click="addOption">Hinzufügen</button>

        </div>
      </div>

      <!-- right button -->
      <div class="flex justify-center items-center mr-4" style="height: calc(100vh - 2.26rem);">
        <button class="button" @click="hasRightQuestion ? goToQuestion() : addQuestion()">
          <font-awesome-icon v-if="hasRightQuestion" icon="chevron-right" size="lg" />
          <font-awesome-icon v-else icon="plus" size="lg" />
        </button>
      </div>

    </div>
  </div>
</template>
<script>
import { QUESTION_TYPES } from './EditQuiz';
import { db } from "../plugins/firebase";
import SelectMediaPopup from "../components/SelectMediaPopup";
import { injectComponentWithReturn } from "../main";
import InfoAndAuthBar from "../components/InfoAndAuthBar";

export default {
  components: { InfoAndAuthBar },
  computed: {
    quiz() {
      return this.$store.state.quiz.quizzes.find(q => q.id === this.$route.params.quizid);
    },
    question() {
      return this.quiz.questions[this.$route.params.question];
    },
    mediaObject() {
      return this.$store.state.media.mediaFiles.filter(file => file.ref.fullPath === this.question.media)[0];
    },
    timerSound() {
      return this.question.timerSound || this.$store.state.settings.timerSound;
    },
    timerSoundMediaObject() {
      return this.$store.state.media.mediaFiles.find(m => m.ref.fullPath.includes(this.timerSound));
    },
    hasLeftQuestion() {
      return this.$route.params.question > 0;
    },
    hasRightQuestion() {
      return this.$route.params.question < this.quiz.questions.length - 1;
    },
  },
  data() {
    return {
      QUESTION_TYPES
    }
  },
  methods: {
    a: console.log,
    goToQuestion(right = true) {
      this.$router.push({
        name: 'edit-question',
        params: {
          quizid: this.$route.params.quizid,
          question: right ? parseInt(this.$route.params.question) + 1 : parseInt(this.$route.params.question) - 1
        }
      });
    },
    updateOption(id, value) {
      const options = this.question.options;
      options[id] = value;
      this.updateQuestion({ options });
    },
    addQuestion() {
      const question = {
        id: this.quiz.questions.length,
        type: QUESTION_TYPES.KNOWLEDGE,
        title: this.quiz.questions.length + 1 + ". Frage",
        options: ["Antwortoption 1", "Antwortoption 2", "Antwortoption 3", "Antwortoption 4"],
        correct: 0
      };
      db.collection("quizzes").doc(this.quiz.id).update({
        ...this.quiz,
        questions: [...this.quiz.questions, question]
      });
      this.$router.push({
        name: 'edit-question',
        params: { quizid: this.quiz.id, question: this.quiz.questions.length }
      });
    },
    setCorrect(id) {
      this.updateQuestion({ correct: id });
    },
    deleteMedia() {
      this.updateQuestion({ media: null });
    },
    removeOption(id) {
      const options = this.question.options;
      options.splice(id, 1);
      this.updateQuestion({ options });
    },
    addOption() {
      const options = this.question.options;
      options.push("Unbenannt");
      this.updateQuestion({ options });
    },
    openMediaPopup() {
      injectComponentWithReturn(SelectMediaPopup).then(media => {
        this.updateQuestion({ media });
      });
    },
    updateQuestion(content) {
      const questionsCopy = JSON.parse(JSON.stringify(this.quiz.questions)),
          questionID = this.$route.params.question;
      questionsCopy[questionID] = { ...questionsCopy[questionID], ...content };
      db.collection("quizzes").doc(this.quiz.id).update({ questions: questionsCopy });
    },
    selectSound() {
      injectComponentWithReturn(SelectMediaPopup, { audio: true }).then(media => {
        console.log(media);
        this.updateQuestion({ timerSound: media });
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.button {
  @apply bg-gray-200 shadow-lg border-2 border-gray-100 rounded-full w-12 h-12 flex justify-center items-center hover:border-gray-500 active:bg-gray-300;
}
</style>